import { useQuery } from '@tanstack/react-query'

import { fetchOnboardingFilters } from 'api/fetchers/marketing-capabilities/resources/onboarding/fetchOnboardingFilters'

export const useOnboardingFilters = () => {
  return useQuery({
    queryKey: ['onboarding-filters'],
    queryFn: ({ signal }: any) => fetchOnboardingFilters()(signal),
    select: (data: any) => data.data,
    enabled: true,
  })
}
